<template>
  <div class="cmi-leicester">
    <div class="page-top">
      <div
        class="parallax"
        style="background:url(/dist/assets/images/ChurchImages/rupc_bg_006.png);"
      ></div>
      <div class="container">
        <h1>Donate</h1>
        <ul>
          <li><router-link to="/" :exact="true">Home</router-link></li>
          <li><router-link to="/donate">Donate</router-link></li>
        </ul>
      </div>
    </div>
    <section class="cmi-donate-section">
      <div class="row">
        <div class="col-md-6 col-md-offset-3">
          <p>
            If you want to donate by direct debit, bank transfer or mobile money
            transfer, please contact us by sending us a message online or via
            our mobile, telephone or e-mail. We will call you back or e-mail you
            to arrange. We will then give you our bank account details and or
            mobile money transfer details.
          </p>
          <p>
            If you want to donate online, please complete the form and click
            <b>Pay</b>.
            <br />
            Many thanks.
          </p>
          <p class="cmi-donate-form-p">
            Give, and it shall be given unto you...
          </p>
          <p class="cmi-donate-form-p">
            Now HE who supplies seed to the sower and bread for food will also
            supply and increase your store of seed and will enlarge the harvest
            of your righteousness
          </p>
        </div>
        <div class="col-md-6 col-md-offset-3">
          <img
            class="img-responsive"
            src="/dist/assets/images/cmi_donate_02.jpg"
          />
        </div>
      </div>
    </section>
    <section class="cmi-donate-view">
      <transition
        name="donate-transition"
        enter-active-class="animated lightSpeedIn"
        leave-active-class="animated zoomOut"
      >
        <div class="row">
          <div class="col-md-6 col-md-offset-3">
            <donate :baseUrl="'Donation/'"></donate>
          </div>
        </div>
      </transition>
    </section>
    <footer-coventry></footer-coventry>
  </div>
</template>
<script>
import Donate from "./Donate";
import FooterCoventry from "./FooterCoventry";
export default {
  components: {
    Donate,
    FooterCoventry,
  },
  props: {
    baseUrl: { type: String },
  },
  data() {
    return {};
  },
  computed: {
    showPayment: function() {
      return this.$store.state.showPaymentUI;
    },
  },
};
</script>
